// extracted by mini-css-extract-plugin
module.exports = {"root":"DiscoverBoats_root__z63Id","title":"DiscoverBoats_title__nYD2n","listingsWrapper":"DiscoverBoats_listingsWrapper__VKMLh","button":"DiscoverBoats_button__yMpLe"};